import React, {Component} from 'react';
import {connect} from 'react-redux';
import OverviewTab from "../../components/overviewTab";
import {
    addAnotherOverviewAttachment, changeOverviewAttachment,
	overviewTabFilterVisibilityReset, changeOverviewTabFilterVisibility,
    changeOverviewPolicyField, getOverviewTabTagsDescription,
    overviewPolicyAttachmentsChange, removeOverviewAttachment,
    requestGetApplicationOverview, requestPostOverviewPolicyForm,
	getOverviewVisibilityOptions, getOverviewTabSizeLimitDescription,
} from "../../actions/overviewTab";
import _ from 'lodash';
import { isAragUser } from "../../helpers/functions";


class OverViewTabHOC extends Component {

	_getParameters = (props) => {
		const calcOffset = parseInt(props.overviewTab.selectedView) * (props.overviewTab.page - 1);
		return {
			applicationId: props.applicationsAndPolicies.selectedApplication.id,
			limit: props.overviewTab.selectedView,
			offset: calcOffset > 0 ? calcOffset : 0,
			includeNoChanges: props.overviewTab.includeNoChanges,
			visibilityBy: props.overviewTab.overviewfilterBy.machineName || ""
		};
	};
	
	handlePageChange = (page) => {
		this.props.changeOverviewPolicyField('page', page);
	};

	handlePageSizeChange = (evt) => {
		this.props.changeOverviewPolicyField('selectedView', parseInt(evt.target.value));
	};

	handleGoAtPrevious = () => {
		if (this.props.overviewTab.page > 1) {
			this.handlePageChange(this.props.overviewTab.page - 1);
		}
	};

	handleGoAtNext = () => {
		if (this.props.overviewTab.page < this.props.overviewTab.totalBoxes) {
			this.handlePageChange(this.props.overviewTab.page + 1);
		}
	};

	handleGoAtStart = () => {
		this.handlePageChange(1);
	};

	handleGoAtEnd = () => {
		this.handlePageChange(this.props.overviewTab.totalBoxes);
	};

	handleGoAtPage = (page) => {
		this.handlePageChange(page);
	};	 

	componentWillMount() {
		if(isAragUser(this.props.user.loggedInUser.roles)){
			this.props.getOverviewVisibilityOptions();
		}
		let route = this.props.router.location.pathname;
		let splitedRoute = _.split(route,'/',4);
		let splitId = splitedRoute[3];
		this.props.getApplicationOverview({
			applicationId:splitId,
			limit: this.props.overviewTab.selectedView,
			offset: 0,
			includeNoChanges: this.props.overviewTab.includeNoChanges,
			visibilityBy: this.props.overviewTab.machineName || ""
		});
		this.props.getOverviewTabTagsDescription();
		this.props.getOverviewTabSizeLimitDescription();
	}

	componentWillReceiveProps(nextProps) {
		// Detect changes in page, page size, or filter
		if (
			this.props.overviewTab.selectedView !== nextProps.overviewTab.selectedView ||
			this.props.overviewTab.page !== nextProps.overviewTab.page ||
			((this.props.overviewTab.overviewfilterBy !== nextProps.overviewTab.overviewfilterBy ||
			this.props.overviewTab.includeNoChanges !== nextProps.overviewTab.includeNoChanges) &&
			this.props.overviewTab.wasFilterButtonPressed && !nextProps.overviewTab.wasFilterButtonPressed)
		) {
			// Build parameters with the latest props
			let parameters = this._getParameters(nextProps);
			nextProps.getApplicationOverview(parameters);
		}
	}

	handleOverviewTabSubmit = (evt) => {
		evt.preventDefault();

		let attachment = this.props.overviewTab.attachment;
		let checkBoxesState = this.props.applicationPolicy.usersOverviewTabCheckBoxes;
		let parameters = this._getParameters(this.props);
		let sendBody = {};
		if(
			this.props.overviewTab.comments !== null
			&& !this.props.overviewTab.comments.trim()
			&& this.props.overviewTab.attachments
			&& this.props.overviewTab.attachments[0]
			&& this.props.overviewTab.attachments[0].attachment
			&& !this.props.overviewTab.attachments[0].attachment.name
		) {
			this.props.changeOverviewPolicyField('badMsg', 'Please, make a comment or upload a file.');
			return;
		}

		if(!checkBoxesState.all && (!checkBoxesState.arag) && (!checkBoxesState.aragAndMedicalExperts) && (this.props.user.loggedInUser.roles[0] !== 'Solicitor') ) {
			this.props.changeOverviewPolicyField('badMsg', 'Please select the comment\'s visibility.');
		}
		else {
			if (this.props.overviewTab.attachments.length === 0 ) {
				if (this.props.user.loggedInUser.roles[0] === 'Solicitor') {
					if (this.props.overviewTab.comments === '')
						sendBody = {
							applicationId: this.props.applicationsAndPolicies.selectedApplication.id,
						};
					else  sendBody = {
						comment: this.props.overviewTab.comments,
						applicationId: this.props.applicationsAndPolicies.selectedApplication.id,
					};
				}
				else {
					let updateCheckBoxes = {...this.props.applicationPolicy.usersOverviewTabCheckBoxes};
					let visibleBySolicitor = false;
					let visibleByMedical = false;
					if (updateCheckBoxes.all === true) {
						visibleBySolicitor = true;
						visibleByMedical = true;
					}
					else if (updateCheckBoxes.aragAndMedicalExperts === true) {
						visibleBySolicitor = false;
						visibleByMedical = true;
					}
					if (this.props.overviewTab.comments === '')
						sendBody = {
							applicationId: this.props.applicationsAndPolicies.selectedApplication.id,
							visibleBySolicitor: visibleBySolicitor,
							visibleByMedical: visibleByMedical
						};
					else  sendBody = {
						comment: this.props.overviewTab.comments,
						applicationId: this.props.applicationsAndPolicies.selectedApplication.id,
						visibleBySolicitor: visibleBySolicitor,
						visibleByMedical: visibleByMedical,
						sendEmail: this.props.overviewTab.sendEmailNotification
					};
				}
			}
			else {
				if (this.props.user.loggedInUser.roles[0] === 'Solicitor') {
					if (this.props.overviewTab.comments === '')
						sendBody = {
							applicationId: this.props.applicationsAndPolicies.selectedApplication.id,
							attachments: _.filter(this.props.overviewTab.attachments, attachment => {
								return attachment.attachment.name
							}).map(attachment => {
                                return {...attachment.attachment, tags: attachment.tags}
                            })
						};
					else  sendBody = {
						comment: this.props.overviewTab.comments,
						applicationId: this.props.applicationsAndPolicies.selectedApplication.id,
                        attachments: _.filter(this.props.overviewTab.attachments, attachment => {
                            return attachment.attachment.name
                        }).map(attachment => {
                            return {...attachment.attachment, tags: attachment.tags}
                        })
					};
				}
				else {
					let updateCheckBoxes = {...this.props.applicationPolicy.usersOverviewTabCheckBoxes};
					let visibleBySolicitor = false;
					let visibleByMedical = false;
					if (updateCheckBoxes.all === true) {
						visibleBySolicitor = true;
						visibleByMedical = true;
					}
					else if (updateCheckBoxes.aragAndMedicalExperts === true) {
						visibleBySolicitor = false;
						visibleByMedical = true;
					}
					if (this.props.overviewTab.comments === '')
						sendBody = {
							applicationId: this.props.applicationsAndPolicies.selectedApplication.id,
                            attachments: _.filter(this.props.overviewTab.attachments, attachment => {
                                return attachment.attachment.name
                            }).map(attachment => {
                                return {...attachment.attachment, tags: attachment.tags}
                            }),
							visibleBySolicitor: visibleBySolicitor,
							visibleByMedical: visibleByMedical
						};
					else  sendBody = {
						comment: this.props.overviewTab.comments,
						applicationId: this.props.applicationsAndPolicies.selectedApplication.id,
                        attachments: _.filter(this.props.overviewTab.attachments, attachment => {
                            return attachment.attachment.name
                        }).map(attachment => {
                        	return {...attachment.attachment, tags: attachment.tags}
						}),
						visibleBySolicitor: visibleBySolicitor,
						visibleByMedical: visibleByMedical,
						sendEmail: this.props.overviewTab.sendEmailNotification
					};
				}
			}
			sendBody = {
				...sendBody,
				...parameters
			}
			this.props.postOverviewPolicyForm(sendBody);
		}
	};

	onDropOverview = (files, attachmentIndex) => {
		files.map((file) => {
			let reader = new FileReader();
			reader.readAsDataURL(file);
			let attachment = {
				name: file.name,
				encodedFile: '',
				fileType: file.type
			};
			let props = this.props;
			reader.onload = function () {
				attachment = {
					...attachment,
					encodedFile: reader.result.substring(reader.result.indexOf("base64,") + 7)
				};
				props.changeOverviewAttachment({
					value: attachment,
					key: 'attachment',
					attachmentIndex: attachmentIndex
				})
			};
			reader.onerror = function (error) {
				console.log('Error: ', error);
			};
		})
	};

	calculateFeaturedOverview = () => {
		let overviews = [...this.props.overviewTab.applicationOverview];
		return [overviews, overviews.length];
	};

    handleDropdownChange = (evt) => {
		let overviewFilterSelectedOption = this.props.overviewTab.overviewVisibilityOptions[evt.target.selectedIndex];
		this.props.changeOverviewPolicyField('overviewfilterBy', overviewFilterSelectedOption);
	}

	handleCheckboxChange = (evt) => {
		this.props.changeOverviewPolicyField(evt.target.name, evt.target.checked);
	}
	
    handleFilterClick = () => {
		this.props.changeOverviewPolicyField('wasFilterButtonPressed', true);
		this.props.changeOverviewPolicyField('page', 1);
		let parameters = this._getParameters(this.props);
		this.props.getApplicationOverview(parameters);
    };		

	handleClearOverviewFilters = () => {
		this.props.overviewTabFilterVisibilityReset();
	};

	render() {
		const overviewVisibilityOptions = (this.props.overviewTab.overviewVisibilityOptions || []).map(opt => ({
			value: opt.machineName,
			label: opt.name
		}));
		
		return (
			<OverviewTab
                onDropdownChange={this.handleDropdownChange}
                onCheckboxChange={this.handleCheckboxChange}
                overviewTabFilterVisibility={this.handleFilterClick}
                changeOverviewAttachment={this.props.changeOverviewAttachment}
                removeOverviewAttachment={this.props.removeOverviewAttachment}
				overviewTabFilterVisibilityReset = {this.handleClearOverviewFilters}
                addAnotherOverviewAttachment={this.props.addAnotherOverviewAttachment}
				ApplicationPolicyStore={this.props.ApplicationPolicyStore}
				CheckUserOverviewTabCheckBox={this.props.CheckUserOverviewTabCheckBox}
				UserRole={this.props.UserRole}
				PageShift={this.props.PageShift}
				CalculateFeaturedOverview={this.calculateFeaturedOverview}//
				ChangeOverViewTabReadMoreState={this.props.ChangeOverViewTabReadMoreState}
				RowData={[]}
				Label="overview"
				HandleInputChange={this.props.changeOverviewPolicyField}
				handleSubmit={this.handleOverviewTabSubmit}//
				overviewTab={this.props.overviewTab}
				OnDrop={this.onDropOverview}
				selectedApplication = {this.props.applicationsAndPolicies.selectedApplication}
				requestApplicationAttachment = {this.props.requestApplicationAttachment}
				overviewVisibilityOptions={overviewVisibilityOptions}
				onPageSizeChange={this.handlePageSizeChange}
                goAtPrevious={this.handleGoAtPrevious}
                goAtNext={this.handleGoAtNext}
                goAtStart={this.handleGoAtStart}
                goAtEnd={this.handleGoAtEnd}
                goAtPage={this.handleGoAtPage}

			/>
		)
	}

}

const mapStateToProps = (state) => {
	return {
		overviewTab: state.overviewTab,
		router: state.router,
		applicationPolicy: state.applicationPolicy,
		applicationsAndPolicies: state.applicationsAndPolicies,
		user: state.user
	}
};

const mapDispatchToProps = (dispatch) => {
	return {
		getApplicationOverview: (params) => {
			dispatch(requestGetApplicationOverview(params))
		},
		updateOverviewPolicyAttachmentsChange: (attachment) => {
			dispatch(overviewPolicyAttachmentsChange(attachment))
		},
		postOverviewPolicyForm: (sendBody) => {
			dispatch(requestPostOverviewPolicyForm(sendBody))
		},
		changeOverviewPolicyField: (field, value) => {
			dispatch(changeOverviewPolicyField(field, value))
		},
		changeOverviewTabFilterVisibility: (key, value) => {
			dispatch(changeOverviewTabFilterVisibility(key, value))
		},
        getOverviewTabTagsDescription: () => {
			dispatch(getOverviewTabTagsDescription())
		},
        getOverviewTabSizeLimitDescription: () => {
			dispatch(getOverviewTabSizeLimitDescription())
		},
        addAnotherOverviewAttachment: (payload) => {
			dispatch(addAnotherOverviewAttachment(payload))
		},
        removeOverviewAttachment: (payload) => {
			dispatch(removeOverviewAttachment(payload))
		},
		overviewTabFilterVisibilityReset: (payload)	 => {
			dispatch(overviewTabFilterVisibilityReset(payload))	
		},
		changeOverviewAttachment: (payload) => {
			dispatch(changeOverviewAttachment(payload))
		},
		getOverviewVisibilityOptions: () => {
			dispatch(getOverviewVisibilityOptions())
		},
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(OverViewTabHOC);
